var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaLegendA4Fr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a4",
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 841.89 595.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h841.89v595.276H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(-1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M73.058 551h571.306c.949 0 1.716.816 1.716 1.823v22.881c0 1.007-.767 1.823-1.716 1.823H73.058Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text20852",
    x: 76.944,
    y: 558.357,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 5,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1523",
    x: 76.944,
    y: 558.357
  }, "Sur certaines lignes d\u2019autobus, un suppl\xE9ment doit \xEAtre pay\xE9 et/ou les places doivent \xEAtre r\xE9serv\xE9es. En outre, veuillez noter que la r\xE9servation de places pour v\xE9lo est obligatoire dans les trains InterCity (IC) du 21 mars au 31 octobre. Veuillez consulter")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1525",
    x: 76.944,
    y: 563.357
  }, "les informations concernant votre train dans l\u2019horaire (en ligne). Faute de place, selon le niveau de zoom, toutes les lignes ne sont pas mentionn\xE9es. Toutes les indications sont sans garantie. Sous r\xE9serve de modifications. Le champ d&apos;application fait foi."))), /*#__PURE__*/React.createElement("text", {
    id: "text493",
    x: 76.722,
    y: 572.645,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 5,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan12865",
    x: 76.722,
    y: 572.645
  }, "Source: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M17.008 527.244h51.024v51.024H17.008Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path973",
    d: "M18.466 528.701h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm1.458 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm10.205 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm4.374 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458H56.37Zm8.747 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458H56.37Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457H22.84Zm1.457 0h1.459v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H35.96Zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm7.29 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H56.37Zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm-46.651 1.456h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H56.37Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-46.651 1.46h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm11.662 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm8.747 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm1.458 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-24.783 1.458h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-32.073 1.458h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.456h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0h1.459v1.457h-1.458zm1.458 0h1.458v1.457h-1.457zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457H56.37Zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm-46.651 1.457h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.459v1.458h-1.458zm1.458 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm8.747 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-39.361 1.458h1.457v1.458H22.84Zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm-40.82 1.458h1.458v1.458h-1.458zm2.916 0h1.457v1.458H22.84Zm10.204 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H56.37Zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458zm-46.651 1.459h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.459v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm8.748 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-40.82 1.458h1.459v1.457h-1.458zm1.459 0h1.457v1.457H22.84Zm1.457 0h1.459v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm-42.277 1.457h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm2.915 0h1.458v1.458h-1.457zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H56.37Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.459h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm5.83 0h1.459v1.458h-1.458zm2.917 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-40.82 1.458h1.459v1.458h-1.458zm1.459 0h1.457v1.458H22.84Zm2.915 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H56.37Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.456h1.458v1.457h-1.458zm4.374 0h1.457v1.457H22.84Zm1.457 0h1.459v1.457h-1.458zm7.29 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm5.832 0h1.458v1.457h-1.458zm8.747 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H56.37Zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm-43.735 1.457h1.458v1.458h-1.458zm4.374 0h1.457v1.458H22.84Zm2.915 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm-34.988 1.458h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H35.96Zm5.832 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm1.458 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-46.651 1.459h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm-46.651 1.458h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457H22.84Zm1.457 0h1.459v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm5.831 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm-43.735 1.457h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm5.832 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm-45.193 1.458h1.458v1.458h-1.458zm8.747 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm-43.735 1.458h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H22.84Zm1.457 0h1.459v1.458h-1.458zm1.458 0h1.458v1.458h-1.457zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H35.96Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H56.37Zm4.374 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458z",
    style: {
      display: "inline",
      fill: "#000",
      strokeWidth: 0.208264
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M628.838 17.008h196.044v22.94H628.838z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M630.289 18.258h192.107v20.659H630.289z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M630.289 38.704h60.702V18.47h-60.702v20.234Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M666.02 27.039h6.563v-5.196h3.092v5.196h6.563l-5.28-5.196h3.918l6.745 6.744-6.745 6.745h-3.921l5.28-5.196h-6.56v5.196h-3.092v-5.196h-6.563l5.28 5.196h-3.916l-6.745-6.744 6.745-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M697.255 31.303c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.544 0-3.211-3.173-3.866-4.205-4.122-3.55-.914-4.224-1.053-4.224-2.142 0-1.19 1.149-1.606 2.143-1.606 1.487 0 2.698.435 2.796 2.142h3.015c0-3.272-2.717-4.56-5.672-4.56-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.025 2.082.555 4.203.814 4.203 2.34 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M714.21 24.264h2.916c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.862c2.559 0 5-1.229 5-4.105 0-1.765-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.925-2.956c0-2.637-1.825-3.51-4.523-3.51h-6.664v14.162Zm3.114-6.307h3.39c1.329 0 2.241.577 2.241 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M728.148 24.264h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.74h6.861c2.56 0 4.998-1.229 4.998-4.105 0-1.765-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.923-2.956c0-2.637-1.823-3.51-4.52-3.51h-6.664v14.162Zm3.115-6.307h3.39c1.33 0 2.242.577 2.242 2.024 0 1.466-1.07 1.864-2.3 1.864h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M756.674 26.603c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.961 3.273-6.961 7.476 0 4.086 2.577 7.359 6.96 7.359 3.472 0 5.91-2.26 6.228-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.797 0-3.85-2.38-3.85-4.74 0-2.48 1.054-4.86 3.85-4.86 1.545 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M758.71 36.005h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M770.56 36.005h3.104v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M787.241 36.005h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M799.464 36.005h3.105v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M810.562 31.303c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.888-1.944 5.888-4.544 0-3.211-3.176-3.866-4.193-4.122-3.55-.914-4.228-1.053-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.142h2.998c0-3.272-2.712-4.56-5.656-4.56-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.123 3.471 4.23 4.025 2.07.555 4.192.814 4.192 2.34 0 1.448-1.659 1.766-2.747 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path513",
    d: "M406.967 82.823H0V17.04h406.965a2.06 2.424 0 0 1 2.06 2.423V80.4c0 1.338-.925 2.423-2.06 2.423z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text735",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 12,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.157 32.43)"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan413",
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan317"
  }, "Abonnement g\xE9n\xE9ral, AG Night, carte mensuelle AG, carte journali\xE8re"))), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan415",
    x: 0,
    y: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan417"
  }, "pour le demi-tarif ainsi que la carte journali\xE8re d\xE9griff\xE9e / carte journali\xE8re"))), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan421",
    x: 0,
    y: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan423"
  }, "promo / carte journali\xE8re d\xE9griff\xE9e Commune avec un abonnement"))), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan426",
    x: 0,
    y: 45
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan428"
  }, "demi-tarif en cours de validit\xE9"))))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 10.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 172.589,
    height: 117.163,
    x: 9.457,
    y: 77.632,
    rx: 1.984,
    ry: 2.085,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline",
    transform: "translate(0 4.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text745",
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(62.56 178.12)"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan739",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan741",
    x: 8.341,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan743",
    x: 11.476,
    y: 0
  }, "m"))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M125.04 172.298v9.44l-107.434.052v-9.494",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g765"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text751",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.075 114.12)"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1228",
    x: 0,
    y: 0
  }, "Chemins")), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1230",
    x: 0,
    y: 7.5
  }, "de fer"))), /*#__PURE__*/React.createElement("g", {
    id: "g763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line753",
    d: "M18.29 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line755",
    d: "M18.29 104.326v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line757",
    d: "M21.056 104.326H44.57",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line759",
    d: "M45.953 104.326v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g783"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text769",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(102.438 114.225)"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1270",
    x: 0,
    y: 0
  }, "Transports")), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1272",
    x: 0,
    y: 7.5
  }, "\xE0 c\xE2bles"))), /*#__PURE__*/React.createElement("g", {
    id: "g781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line771",
    d: "M103.358 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line773",
    d: "M103.358 104.326v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line775",
    d: "M106.124 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line777",
    d: "M131.021 104.326v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g826",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text797",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(145.12 146.932)"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan314",
    x: 0,
    y: 0
  }, "Demandez")), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan316",
    x: 0,
    y: 7.5
  }, "la validit\xE9")), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan422",
    x: 0,
    y: 15
  }, "sur place")))), /*#__PURE__*/React.createElement("g", {
    id: "g824"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line818",
    d: "M145.893 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line820",
    d: "M148.659 137.151h23.514",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line822",
    d: "M173.556 137.151v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g854"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text840",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(145.12 114.225)"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1292",
    x: 0,
    y: 0
  }, "Bateaux"))), /*#__PURE__*/React.createElement("g", {
    id: "g852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line842",
    d: "M145.893 100.564h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line844",
    d: "M145.893 104.326v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line846",
    d: "M148.659 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line848",
    d: "M173.556 104.326v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g892"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text868",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(59.806 114.214)"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1250",
    x: 0,
    y: 0
  }, "Autobus"))), /*#__PURE__*/React.createElement("g", {
    id: "g890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line870",
    d: "M61.07 100.564h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line872",
    d: "M60.824 104.326v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line874",
    d: "M63.59 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line876",
    d: "M88.488 104.326v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "line880",
    d: "M60.824 100.564h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g888"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M60.824 104.326v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line884",
    d: "M63.59 104.326h23.514",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line886",
    d: "M88.488 104.326v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g925",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text908",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.075 146.933)"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1312",
    x: 0,
    y: 0
  }, "Libre")), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1314",
    x: 0,
    y: 7.5
  }, "circulation")))), /*#__PURE__*/React.createElement("g", {
    id: "g923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line911",
    d: "M18.167 125.783h27.664",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line913",
    d: "M18.167 133.361h27.664",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line915",
    d: "M18.168 137.151h27.663",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g921"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line917",
    d: "M18.413 129.572h27.173",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line919",
    d: "M18.167 129.572h27.664",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1007",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text963",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(59.756 146.933)"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1334",
    x: 0,
    y: 0
  }, "Voyages \xE0")), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1336",
    x: 0,
    y: 7.5
  }, "prix r\xE9duit"))), /*#__PURE__*/React.createElement("g", {
    id: "g971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line965",
    d: "M60.825 125.783v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line967",
    d: "M63.592 125.783h23.513",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line969",
    d: "M88.489 125.783v0",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line973",
    d: "M60.825 133.361v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line975",
    d: "M63.592 133.361h23.513",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line977",
    d: "M88.489 133.361v0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g987"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line981",
    d: "M60.825 137.151v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line983",
    d: "M63.592 137.151h23.513",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line985",
    d: "M88.489 137.151v0",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line989",
    d: "M60.825 129.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line991",
    d: "M63.592 129.572h23.513",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line993",
    d: "M88.489 129.572v0",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line997",
    d: "M60.825 129.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line999",
    d: "M63.592 129.572h23.513",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.76634"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line1001",
    d: "M88.489 129.572v0",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1036",
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1031",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(102.438 146.933)"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1356",
    x: 0,
    y: 0
  }, "Pas de")), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1358",
    x: 0,
    y: 7.5
  }, "r\xE9duction")))), /*#__PURE__*/React.createElement("path", {
    id: "line1034",
    d: "M103.358 137.151h27.664",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1042",
    x: 32.786,
    y: 88.501,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1038",
    x: 32.786,
    y: 88.501
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1047",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(17.075 88.501)"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1208",
    x: 0,
    y: 0
  }, "Cr\xE9\xE9 le")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaLegendA4Fr);
export default __webpack_public_path__ + "static/media/ga_legend_a4_fr.bc81276421fb8da332cac307a94a050b.svg";
export { ForwardRef as ReactComponent };